<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Deposit</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" v-model="deposit" placeholder="Deposit amount" :class="{ 'is-danger': errors.deposit }">
                    <span class="icon is-left">
                        <i class="fas fa-dollar-sign"></i>
                    </span>
                    <p v-if="errors.deposit" class="help is-danger">{{ errors.deposit[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            deposit: {
                get() {
                    return this.$store.getters.getNewPricePlan.deposit
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'deposit', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/DepositInput.vue